import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import TicketList from "./TicketsList";

export default function HelpDesk() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row justify-between  gap-5">
        <PageHeader title="HELP DESK ( ALL TICKETS )" />
        <CustomButton
          text="Raise New Ticket"
          color="bg-primary-500"
          onClick={() => navigate("/help/create-new-ticket")}
        />
      </div>
      <TicketList />
    </div>
  );
}
